export enum GameDisallowedReason {

  // School service provides.
  District = 'District',
  Parent = 'Parent',
  ParentOptIn = 'ParentOptIn',
  Grade = 'Grade',
  Homework = 'Homework',

  //  Game service provides.
  PlayTime = 'PlayTime'
}
